<template>
  <div class="list">
    <van-nav-bar
      :border="false"
      @click-left="$store.dispatch('back')"
      placeholder
      :fixed="true"
      title="我的已购"
    >
      <template #left>
        <van-icon size="40rpx" name="arrow-left" color="#333" />
      </template>
    </van-nav-bar>
    <List
      :finished="finished"
      finished-text="没有更多了"
      @load="loadmore"
      class="content"
      v-if="list.length"
    >
      <BuyCard v-for="item of list" :key="item.id" :cardData="item"></BuyCard>
    </List>
    <div class="nodata" style="height: calc(100vh - 200rpx)" v-else>
      <img
        src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/nodata.png"
        alt=""
      />
      <p>暂无相关内容~</p>
      <p></p>
    </div>
  </div>
</template>


<script>
import List from "vant/es/list/index";
import "vant/es/list/style/index";
import BuyCard from "@/components/BuyCard";
export default {
  components: {
    BuyCard,
    List,
  },
  computed: {},
  data() {
    return {
      page: 1,
      list: [{},{}],
      limit: 10,
      loading: false,
      finished: false,
    };
  },
  mounted(){
     this.$api({
      methods:'get',
      url:'/api/users/plat/goods',
      data:{
        is_show : 1,
        flat_id : this.$store.state.plat_id
      }
     }).then(res=>{
       if(res.code==0){
         this.list = res.data.courses
       }else{
        this.$toast(res.msg)
       }
     })
  },
  methods: {
    loadmore() {
      this.finished = true;
    },
  },
};
</script>

<style scoped>
.list {
  height: 100vh;
  padding-top: 40rpx;
  box-sizing: border-box;
}
</style>